import React from 'react';
import { useSelector } from 'react-redux';

import { SEARCH_BOTTOM_BLOCK_ID, SEARCH_TOP_BLOCK_ID } from '../../../common/components/CustomInjectionBlock/constants';

import * as commonSelectors from '../../../common/redux/selectors/common';
import { isMobileUserAgent } from '@/modules/common/helpers/userAgent';

import CustomInjectionBlock from '../../../common/components/CustomInjectionBlock/CustomInjectionBlock';
import SearchPanel from '../../../common/components/SearchPanel/SearchPanel';
import StickyContainer from '../../../common/components/StickyContainer/StickyContainer';

import styles from './Header.module.scss';

function Header() {
  const offsetTop = useSelector(commonSelectors.offsetTopSelector);
  const dockMobile = useSelector(commonSelectors.dockMobileSelector);

  return (
    <StickyContainer offsetTop={isMobileUserAgent && dockMobile ? 0 : offsetTop} className={styles.Wrapper}>
      <CustomInjectionBlock id={SEARCH_TOP_BLOCK_ID} />
      <SearchPanel />
      <CustomInjectionBlock id={SEARCH_BOTTOM_BLOCK_ID} />
    </StickyContainer>
  );
}

export default Header;
